import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import Tool from './tool';
import Pattern from './pattern';
import request from '@/plugins/request';
var Form = {
  Rule: {
    required: function required(_ref) {
      var _ref$type = _ref.type,
        type = _ref$type === void 0 ? 'any' : _ref$type,
        _ref$label = _ref.label,
        label = _ref$label === void 0 ? '' : _ref$label,
        _ref$trigger = _ref.trigger,
        trigger = _ref$trigger === void 0 ? 'change' : _ref$trigger,
        _ref$message = _ref.message,
        message = _ref$message === void 0 ? "\u8BF7\u8F93\u5165".concat(label) : _ref$message;
      return {
        type: type,
        required: true,
        message: message,
        trigger: trigger
      };
    },
    max: function max(_ref2) {
      var _ref2$label = _ref2.label,
        label = _ref2$label === void 0 ? '' : _ref2$label,
        _ref2$max = _ref2.max,
        _max = _ref2$max === void 0 ? Number : _ref2$max,
        _ref2$trigger = _ref2.trigger,
        trigger = _ref2$trigger === void 0 ? 'change' : _ref2$trigger,
        _ref2$message = _ref2.message,
        message = _ref2$message === void 0 ? "".concat(label, "\u6700\u591A").concat(_max, "\u4E2A\u5B57\u7B26") : _ref2$message;
      return {
        min: 1,
        max: _max,
        message: message,
        trigger: trigger
      };
    },
    min: function min(_ref3) {
      var _ref3$label = _ref3.label,
        label = _ref3$label === void 0 ? '' : _ref3$label,
        _ref3$min = _ref3.min,
        _min = _ref3$min === void 0 ? Number : _ref3$min,
        _ref3$trigger = _ref3.trigger,
        trigger = _ref3$trigger === void 0 ? 'change' : _ref3$trigger,
        _ref3$message = _ref3.message,
        message = _ref3$message === void 0 ? "".concat(label, "\u6700\u5C11").concat(_min, "\u4E2A\u5B57\u7B26") : _ref3$message;
      return {
        min: _min,
        message: message,
        trigger: trigger
      };
    },
    email: function email(_ref4) {
      var _ref4$trigger = _ref4.trigger,
        trigger = _ref4$trigger === void 0 ? 'change' : _ref4$trigger,
        _ref4$message = _ref4.message,
        message = _ref4$message === void 0 ? '邮箱格式不正确' : _ref4$message;
      return {
        type: 'email',
        message: message,
        trigger: trigger
      };
    },
    mobile: function mobile(_ref5) {
      var _ref5$trigger = _ref5.trigger,
        trigger = _ref5$trigger === void 0 ? 'change' : _ref5$trigger,
        _ref5$message = _ref5.message,
        message = _ref5$message === void 0 ? '手机号码格式不正确' : _ref5$message;
      return {
        pattern: /^((13)|(14)|(15)|(16)|(17)|(18)|(19))\d{9}$/,
        message: message,
        trigger: trigger
      };
    },
    idCard: function idCard(_ref6) {
      var _ref6$trigger = _ref6.trigger,
        trigger = _ref6$trigger === void 0 ? 'change' : _ref6$trigger;
      return {
        validator: Form.Validator.idCard,
        trigger: trigger
      };
    },
    telephone: function telephone(_ref7) {
      var _ref7$trigger = _ref7.trigger,
        trigger = _ref7$trigger === void 0 ? 'change' : _ref7$trigger,
        _ref7$message = _ref7.message,
        message = _ref7$message === void 0 ? '电话号码格式不正确' : _ref7$message;
      return {
        pattern: /0\d{2,3}-\d{7,8}/,
        message: message,
        trigger: trigger
      };
    },
    number: function number(_ref8) {
      var _ref8$trigger = _ref8.trigger,
        trigger = _ref8$trigger === void 0 ? 'change' : _ref8$trigger;
      return {
        validator: Form.Validator.number,
        trigger: trigger
      };
    },
    positiveNumber: function positiveNumber(_ref9) {
      var _ref9$trigger = _ref9.trigger,
        trigger = _ref9$trigger === void 0 ? 'change' : _ref9$trigger;
      return {
        validator: Form.Validator.positiveNumber,
        trigger: trigger
      };
    },
    positive: function positive(_ref0) {
      var _ref0$trigger = _ref0.trigger,
        trigger = _ref0$trigger === void 0 ? 'change' : _ref0$trigger;
      return {
        validator: Form.Validator.positive,
        trigger: trigger
      };
    }
  },
  Validator: {
    /**
     * 校验是否为整数
     * @param rule
     * @param value
     * @param callback
     */
    number: function number(rule, value, callback) {
      if (Tool.isNotNull(value) && !Pattern.isInteger(value)) {
        callback(new Error('请输入整数'));
      } else {
        callback();
      }
    },
    /**
     * 校验是否为正整数
     * @param rule
     * @param value
     * @param callback
     */
    positiveNumber: function positiveNumber(rule, value, callback) {
      if (Tool.isNotNull(value) && (!Pattern.isInteger(value) || parseInt(value) < 0)) {
        callback(new Error('请输入大于0的正整数'));
      } else {
        callback();
      }
    },
    /**
     * 校验是否为小数
     * @param rule
     * @param value
     * @param callback
     */
    decimal: function decimal(rule, value, callback) {
      if (Tool.isNotNull(value) && !Pattern.isDecimal(value)) {
        callback(new Error('请输入小数'));
      } else {
        callback();
      }
    },
    /**
     * 校验是否为大于0的小数
     * @param rule
     * @param value
     * @param callback
     */
    positiveDecimal: function positiveDecimal(rule, value, callback) {
      if (Tool.isNotNull(value) && (!Pattern.isDecimal(value) || parseInt(value) <= 0)) {
        callback(new Error('请输入大于0的小数'));
      } else {
        callback();
      }
    },
    /**
     * 校验是为大于0
     * @param rule
     * @param value
     * @param callback
     */
    positive: function positive(rule, value, callback) {
      if (Tool.isNotNull(value) && parseFloat(value) <= 0) {
        callback(new Error('请输入大于0的数'));
      } else {
        callback();
      }
    },
    /**
     * 校验是否为合法的ip地址
     * @param rule
     * @param value
     * @param callback
     */
    ip: function ip(rule, value, callback) {
      if (Tool.isNotNull(value) && !Pattern.isIp(value)) {
        callback(new Error('请输入正确的IP地址'));
      } else {
        callback();
      }
    },
    /**
     * 校验是否为手机号码或者固话
     * @param rule
     * @param value
     * @param callback
     */
    telephoneMobile: function telephoneMobile(rule, value, callback) {
      if (Tool.isNotNull(value) && !Pattern.isTelephoneOrMobile(value)) {
        callback(new Error('请输入正确的手机号码或者固话号码'));
      } else {
        callback();
      }
    },
    /**
     * 校验是否固话
     * @param rule
     * @param value
     * @param callback
     */
    telephone: function telephone(rule, value, callback) {
      if (Tool.isNotNull(value) && !Pattern.isTelephone(value)) {
        callback(new Error('请输入正确的固定电话'));
      } else {
        callback();
      }
    },
    /**
     * 校验是否为手机号码
     * @param rule
     * @param value
     * @param callback
     */
    mobile: function mobile(rule, value, callback) {
      if (Tool.isNotNull(value) && !Pattern.isMobile(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    },
    /**
     * 校验是否中文
     * @param rule
     * @param value
     * @param callback
     */
    chinese: function chinese(rule, value, callback) {
      if (Tool.isNotNull(value) && !Pattern.isChinese(value)) {
        callback(new Error('请输入中文'));
      } else {
        callback();
      }
    },
    /**
     * 校验是否为身份证号
     * @param rule
     * @param value
     * @param callback
     */
    idCard: function idCard(rule, value, callback) {
      if (Tool.isNotNull(value) && !Pattern.isIdCard(value)) {
        callback(new Error('请输入正确的身份证号'));
      } else {
        callback();
      }
    }
  }
};
export default Form;